import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Midpoint tasks:", -1)
const _hoisted_2 = { class: "prompt-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "prompt" }, [
  /*#__PURE__*/_createElementVNode("b", null, "End of Term tasks:"),
  /*#__PURE__*/_createTextVNode(" For which tasks would you like students to rate their teammates and themselves? "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-item custom" }, "*")
], -1)
const _hoisted_4 = ["onClick", "disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Confirm Copy & Replace", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to replace the existing End of Term tasks with the Midpoint tasks?", -1)
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", null, "Midterm tasks to be copied:")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", null, "End of Term tasks to be replaced:")
  ])
], -1)
const _hoisted_10 = ["onClick"]

import { computed, ref } from "vue";
import TandemInputWrapper from "@/components/TandemInputWrapper.vue";
import TaskInput from "@/components/TaskInput.vue";
import TandemModal from "@/components/TandemModal.vue";

const TASK_LIMIT_MIN = 1;
const TASK_LIMIT_MAX = 10;

export interface FormState {
  midterm_tasks: string[];
  end_of_term_tasks: string[];
}

export interface FormErrors {
  midterm_tasks?: string[];
  end_of_term_tasks?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTaskForm',
  props: {
    modelValue: {},
    errors: {}
  },
  emits: ["delete", "update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

const showModal = ref(false);





const formData = computed({
  get: () => {
    return props.modelValue;
  },
  set: (value: FormState) => {
    emit("update:modelValue", value);
  },
});

const isMidtermTaskEmpty = computed(() => {
  return formData.value.midterm_tasks.every((task) => task.trim().length === 0);
});

function copyTasks() {
  const midtermTasks = formData.value.midterm_tasks.filter(
    (task) => task.trim().length > 0
  );
  formData.value.end_of_term_tasks = midtermTasks;
  emit("update:modelValue", formData.value);
}

const handleCopyTasks = () => {
  const endOfTermTasks = formData.value.end_of_term_tasks.filter(
    (task) => task.trim().length > 0
  );
  if (endOfTermTasks.length === 0) {
    copyTasks();
  } else {
    showModal.value = true;
  }
};

const handleConfirmCopy = () => {
  copyTasks();
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TandemInputWrapper, {
      name: "midterm_tasks",
      "help-text": `Students will rate their team members and themselves part of the way through the term on the tasks you list below. Remember, Tandem will ask about teamwork skills separately. (Limit ${TASK_LIMIT_MAX} tasks)`,
      errors: _ctx.errors?.midterm_tasks,
      "label-extra-classes": "case-inherit",
      required: ""
    }, {
      label: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(" For which tasks would you like students to rate their teammates and themselves? ")
      ]),
      default: _withCtx(() => [
        _createVNode(TaskInput, {
          "min-num-values": TASK_LIMIT_MIN,
          "max-num-values": TASK_LIMIT_MAX,
          modelValue: formData.value.midterm_tasks,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.midterm_tasks) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["help-text", "errors"]),
    _createVNode(TandemInputWrapper, {
      name: "end_of_term_tasks",
      "help-text": `Most courses repeat midpoint tasks at the end of term. Remember, Tandem will ask about teamwork skills separately. (Limit ${TASK_LIMIT_MAX} tasks)`,
      errors: _ctx.errors?.end_of_term_tasks,
      "label-extra-classes": "case-inherit copy-above-q",
      required: ""
    }, {
      label: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            class: "btn btn-yellow",
            onClick: _withModifiers(handleCopyTasks, ["prevent"]),
            disabled: isMidtermTaskEmpty.value
          }, " Copy Midpoint Tasks ", 8, _hoisted_4)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(TaskInput, {
          "min-num-values": TASK_LIMIT_MIN,
          "max-num-values": TASK_LIMIT_MAX,
          modelValue: formData.value.end_of_term_tasks,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.end_of_term_tasks) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["help-text", "errors"]),
    _createVNode(TandemModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = false))
    }, {
      title: _withCtx(() => [
        _hoisted_5
      ]),
      directions: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.midterm_tasks, (task) => {
              return (_openBlock(), _createElementBlock("li", { key: task }, _toDisplayString(task), 1))
            }), 128))
          ]),
          _hoisted_9,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.end_of_term_tasks, (task) => {
              return (_openBlock(), _createElementBlock("li", { key: task }, _toDisplayString(task), 1))
            }), 128))
          ])
        ])
      ]),
      buttons: _withCtx(({ close }) => [
        _createElementVNode("button", {
          type: "button",
          class: "btn",
          onClick: close
        }, " Cancel ", 8, _hoisted_10),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-burg",
          onClick: handleConfirmCopy
        }, " Yes, replace ")
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})